import React, { FC } from 'react';

import {
  GetPdpBaseInfo_catalog_product_base_info_product_trait_list,
  useCatalogProductIdParams,
  usePdpBaseInfo,
} from '@domains/pdp-common';

import { RelatedItemList } from '../components/RelatedItemList';
import { PdpRelationType } from '../graphql/related-item-list_types.2';
import { PDPRelatedItemList, useGetPDPRelatedItemListQuery } from '../hooks/useGetPDPRelatedItemListQuery';
import { useInitLikedProducts } from '../hooks/useInitLikedProducts';

export interface RelatedItemContainerProps {
  relationType: 'SAMPLE' | 'SAMPLE_ORIGINAL';
}

function isEnabled(trait_list: GetPdpBaseInfo_catalog_product_base_info_product_trait_list[] | null) {
  return !!trait_list?.find((o) => o.type === 'SAMPLE' || o.type === 'SAMPLE_ORIGINAL');
}

export const RelatedItemContainer: FC<React.PropsWithChildren<RelatedItemContainerProps>> = ({ relationType }) => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo({ catalog_product_id });
  const { data } = useGetPDPRelatedItemListQuery({
    id: catalog_product_id,
    relationType: relationType as PdpRelationType,
    refetchOnWindowFocus: false,
    enabled: isEnabled(product.trait_list),
  });

  useInitLikedProducts({
    data,
    convert: convertToIdList,
  });

  if (!data?.ui_item_list.length) {
    return null;
  }

  return <RelatedItemList title={data?.title ?? ''} items={data?.ui_item_list} />;
};

const convertToIdList = (data: PDPRelatedItemList) => {
  const list: string[] = [];
  data?.ui_item_list.forEach(({ catalog_product_id }) => {
    catalog_product_id && list.push(catalog_product_id);
  });
  return list;
};
